const styles = {
  licenseText: {
    backgroundColor: 'lightgrey',
    display: 'inline-block'
  }
};

export default styles;
